const statusCodes = {
    401: 'unauthorized',
    404: 'not_found',
    422: 'unprocessable_entity',
};
const defaultStatusCode = 'unknown';
const getCode = (status, data) => {
    if (data && typeof data === 'object' && 'statusCode' in data) {
        return data.statusCode;
    }
    if (status && statusCodes[status]) {
        return statusCodes[status];
    }
    return defaultStatusCode;
};
const getMessage = (errorMessage, data) => {
    if (data && typeof data === 'object') {
        if ('message' in data)
            return data.message;
        if ('error' in data)
            return data.error;
    }
    return errorMessage;
};
const getErrors = (data) => {
    if (data && typeof data === 'object' && 'errors' in data) {
        return data.errors;
    }
    return undefined;
};
class OMSError extends Error {
    code;
    errors;
    constructor(errorMessage, status, data) {
        const code = getCode(status, data);
        const message = getMessage(errorMessage, data);
        const errors = getErrors(data);
        super(message);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OMSError);
        }
        this.name = 'OMSError';
        this.code = code;
        if (errors)
            this.errors = errors;
    }
}
export default OMSError;
